import { useNavigate } from "react-router-dom"
import { Button } from "../../../components/ui/button"
import placeholder from "../../../util/placeholder"
import PageSpinner from "../../../components/PageSpinner"
import useSWR from "swr"
import { fetcher } from "../../../util/axiosConfig"

export default function Zones() {
  const navigate = useNavigate()
  const { data, isLoading, error, mutate } = useSWR("newAdmin/truck-category-all", fetcher)
  const categories: ZoneTrucks[] = data?.truckCategories

  if (isLoading) {
    return <PageSpinner />
  }

  return (
    <div className="min-h-screen">
      <main className="flex-1 p-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex justify-between items-center mb-8">
            <h1 className="text-2xl font-bold text-primary">Zone Configuration</h1>
          </div>

          {error ? (
            <div className="bg-red-50 border border-red-200 text-red-700 p-4 rounded-md">
              {error?.message ?? "Something went wrong."}
              <Button variant="outline" className="mt-2 ml-2" onClick={mutate}>
                Retry
              </Button>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {categories?.map((category) => (
                <div
                  key={category.id}
                  onClick={() => navigate(`truck-zones/${category.id}`, { state: category })}
                  className="border-2 hover:cursor-pointer hover:border-primary border-black hover:shadow-md bg-white rounded-lg overflow-hidden"
                >
                  <div className="h-48 bg-gray-100 flex items-center justify-center">
                    {category.image ? (
                      <img
                        src={category.image.includes("example") ? placeholder : category.image}
                        alt={category.name}
                        className="w-full h-full object-contain p-4"
                      />
                    ) : (
                      <div className="text-gray-400">No Image</div>
                    )}
                  </div>
                  <div className="p-4">
                    <div className="font-semibold text-lg">{category.name} {category.code}</div>
                    <div className="mt-1 text-sm text-gray-500">
                      {category.zones.length || 0} Zone{category.zones.length !== 1 ? "s" : ""}
                    </div>
                  </div>
                </div>
              ))}

              {categories?.length === 0 && (
                <div className="col-span-3 bg-gray-50 border border-gray-200 rounded-lg p-8 text-center">
                  <p className="text-gray-500">No vehicle categories found.</p>
                </div>
              )}
            </div>
          )}
        </div>
      </main>
    </div>
  )
}

